import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { startPRLoading, stopPRLoading } from './loader';

const fetchCommonAreasDone = payload => ({
    type: TYPES.FETCH_COMMON_AREAS_DONE,
    payload,
});

export const fetchCommonAreas = () => dispatch => {
      dispatch(startPRLoading())
    return client.fetchCommonAreas()
        .then(
            response => {
                if (response.ok || response.status === 200) {
                    response.json().then(responsejson => {
                        dispatch(fetchCommonAreasDone(responsejson.data))
                        dispatch(stopPRLoading())
                    }
                    )
                }
            }
        );
};

